import type { BlobDataRequest, BlobDataResponse } from '@/models/blob'
import type { BlobResponseDTO } from '@/models/dto/blob-dto'
import { mapToBlobRequestDTO, mapToBlobResponse } from '@/models/mappers/blob-mapper'
import { makeRequest, type MakeRequestOptions } from './make-request'

type BlobCrudType = () => {
    post: (file: BlobDataRequest, options?: Omit<MakeRequestOptions, 'method'>) => Promise<BlobDataResponse>
    put: (
        path: string,
        file: BlobDataRequest,
        options?: Omit<MakeRequestOptions, 'method'>,
    ) => Promise<BlobDataResponse>
    delete: (body: string, options?: Omit<MakeRequestOptions, 'method'>) => Promise<void>
}

const BLOB_URL =
    typeof window === 'undefined'
        ? `${process.env.API_URL}/api/v1/Blob`
        : `${location.origin}${process.env.NEXT_PUBLIC_BASEPATH}/api/v1/Blob`
const BLOB_TAG = 'blob'

const blobCRUD: BlobCrudType = () => ({
    post: async (file, options) => {
        const blobRequestDTO = mapToBlobRequestDTO(file)
        const url = new URL(BLOB_URL)
        const body = new FormData()
        body.append('Blob', blobRequestDTO.Blob)
        body.append('Folder', blobRequestDTO.Folder)
        const blobResponseDTO = await makeRequest<BlobResponseDTO>(url, {
            method: 'POST',
            body,
            next: { tags: [BLOB_TAG] },
            ...options,
        })
        const blobResponse = mapToBlobResponse(blobResponseDTO)
        return blobResponse
    },
    put: async (path, file, options) => {
        const blobRequestDTO = mapToBlobRequestDTO(file)
        const url = new URL(BLOB_URL)
        url.searchParams.append('oldBlobPath', path)
        const body = new FormData()
        body.append('Blob', blobRequestDTO.Blob)
        body.append('Folder', blobRequestDTO.Folder)
        const blobResponseDTO = await makeRequest<BlobResponseDTO>(url, {
            method: 'PUT',
            body,
            next: { tags: [BLOB_TAG] },
            ...options,
        })
        const blobResponse = mapToBlobResponse(blobResponseDTO)

        return blobResponse
    },
    delete: async (body, options) => {
        const url = new URL(BLOB_URL)
        await makeRequest(url, { method: 'DELETE', body, ...options })
    },
})

export { BLOB_TAG, blobCRUD, type BlobCrudType }
